import React from "react"
import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../render/table/table-cell";
import FieldViewSmall from "../../../../render/view-small"
import {isBulkSelection} from "../../../../../gd/right-click-menu"
import FieldProto from "../../../../proto/field-proto"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"

// const debug = "FieldDropdown_TableCell"
const debug = false


export default class FieldDropdown_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) return false
        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {

        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueChange(value:any, hidePopover:boolean=true) {

        hidePopover && this.hidePopover()

        // if field has tableCellOnValueChange - use it !!!
        if (this.props.field.fieldParams.tableCellOnValueChange) {
            this.props.field.fieldParams.tableCellOnValueChange(this.props.listItem, value, this.props.manager)
            return
        }

        // Otherwise default = custom field

        this.props.listItem.item.setCustomFieldValue(this.props.field.fieldId, value)
        this.props.listItem.item.save()

        this.props.listItem.updateLastUpdateTime() // otherwise it wont re-render
        FieldProto_updateView(this.props.manager, this.props.field)
    }

    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueChange(null, false)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    onOptionClick = (option:Option) => {

        if (!option) {
            this.onValueChange(null)
        } else {
            this.onValueChange(option.value)
        }
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderHovered() {

        const field: FieldProto     = this.props.field
        const hasValue: boolean     = field.hasValue(this.props.listItem.item)
        const classes: string       = Classes("cell-flex ui5-txt-less-important-small is-hovered", {})

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
                    <div className="ui5-field-editable is-hovered size-small w-100-percent h-100-percent">

                        {/*<div className="flex-row-left-center">*/}
                            <FieldViewSmall model={this.props.listItem.item} field={this.props.field}/>
                        {/*</div>*/}


                        <div className="buttons m-l-5">
                            {hasValue && field.canResetValue && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                            <div className="btn-arrow"/>
                        </div>

                    </div>

                    {this.state.showPopover &&
                        <field.components.PopoverMenu {...this.props} parent={this} />
                    }

                </div>
            </React.Fragment>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex p-h-0")

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>

                    <div className="ui5-field-editable size-small w-100-percent h-100-percent">
                        <FieldViewSmall model={this.props.listItem.item} field={this.props.field}  />
                    </div>

                </div>
            </React.Fragment>
        )
    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()
    }
}



